import styled from 'styled-components'
import MuiIconButton from '@material-ui/core/IconButton'

const IconButton = styled(MuiIconButton)``

export default IconButton
